export default __webpack_public_path__ + "static/media/bg_3.f14f895b.png";